module.exports = __webpack_public_path__ + "static/media/vbn-picture-2.cc768e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-picture-2.jpg
// module id = 579
// module chunks = 0